{
  "common.close": "Funga",
  "common.athleteFallback": "mwanariadha {id}",
  "splash.title": "{app} — Taswira Hai ya Shughuli",
  "splash.tagline": "Ramani Hai kwa Data Yako ya&nbsp;Strava",
  "splash.demo": "Onyesho",
  "tab.query.title": "Ramani ya {name}",
  "tab.query.heading": "Tafuta Shughuli:",
  "tab.query.optDays": "siku za karibuni",
  "tab.query.optActivities": "shughuli za karibuni",
  "tab.query.optIds": "Namba za Shughuli",
  "tab.query.optDates": "Kipindi cha Tarehe",
  "tab.query.idsPlaceholder": "weka namba za shughuli hapa",
  "tab.query.after": "Baada ya:",
  "tab.query.before": "Kabla ya:",
  "tab.query.autozoom": "Kuza <i class=\"hf hf-bullseye\"></i> kiotomatiki kwenye matokeo baada ya kupakia",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> Tafuta",
  "tab.query.createAccount": "Fungua akaunti na/au ingia.",
  "tab.query.sports": "Michezo:",
  "tab.query.allSports": "Michezo yote",
  "tab.query.sportsExcept": "Yote isipokuwa",
  "tab.query.sportsNone": "Hakuna",
  "tab.query.loadingSports": "Inapakia michezo…",
  "tab.query.sportsFailed": "Imeshindikana kupakia michezo ya ramani hii",
  "tab.query.noSports": "Bado hakuna shughuli",
  "tab.activities.title": "Shughuli Zilizoonyeshwa",
  "tab.activities.clearSelection": "Futa Uteuzi",
  "tab.activities.renderSelected": "Onyesha zilizoteuliwa",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> Kuza hadi uteuzi",
  "tab.controls.title": "Mipangilio ya Tabaka",
  "tab.controls.timescale": "Kipimo cha muda <i>&tau;</i>",
  "tab.controls.timescaleHint": "kasi ya uchezaji",
  "tab.controls.period": "Kipindi <i>T</i>",
  "tab.controls.periodHint": "shughuli ~ modeli",
  "tab.controls.dotSize": "Ukubwa wa nukta",
  "tab.controls.pathWidth": "Upana wa njia",
  "tab.controls.pathWidthHint": "sifuri huficha njia",
  "tab.controls.colors": "Rangi",
  "tab.controls.colorsHint": "zungusha rangi",
  "tab.controls.shadows": "Vivuli",
  "tab.profile.loginTitle": "Ingia",
  "tab.profile.anonNote": "Ingia kwa Strava ili uone shughuli zako, na kusimamia akaunti yako ya Heatflask.",
  "tab.profile.loginLink": "Ingia kwa Strava",
  "tab.profile.editOnStrava": "Hariri wasifu wako kwenye Strava",
  "tab.profile.indexNote": "Tunaorodhesha muhtasari wa shughuli zako ili uzipate haraka.",
  "tab.profile.viewIndex": "Tazama orodha",
  "tab.profile.sharedMaps": "Ramani za Kushiriki",
  "tab.profile.sharedMapsNote": "Imezimwa: ni wewe tu unayeona shughuli zako kwenye Heatflask. Imewashwa: yeyote mwenye kiungo cha ramani yako anaweza kuona shughuli ulizoweka hadharani kwenye Strava. Shughuli zako za faragha zinabaki zako kwa vyovyote vile. <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">Jinsi faragha inavyofanya kazi</a>",
  "tab.profile.logout": "Toka",
  "tab.profile.deleteAccount": "Futa Akaunti",
  "tab.profile.deleteConfirm": "Futa akaunti yako ya Heatflask?\n\nHii inaondoa shughuli zako zilizoorodheshwa na kubatilisha ruhusa ya Heatflask kwa data yako ya Strava. Haiwezi kutenduliwa.",
  "tab.profile.languageHeading": "Lugha",
  "tab.profile.languageAuto": "Kiotomatiki",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">Tusaidie kusahihisha au kuongeza tafsiri!</a>",
  "tab.profile.unitsHeading": "Vipimo",
  "tab.profile.unitsAuto": "Kiotomatiki",
  "tab.profile.unitsMetric": "Metriki (km, m)",
  "tab.profile.unitsImperial": "Kiingereza (maili, futi)",
  "tab.profile.textSizeHeading": "Ukubwa wa maandishi",
  "tab.profile.textSmaller": "Ndogo zaidi",
  "tab.profile.textReset": "Kawaida",
  "tab.profile.textLarger": "Kubwa zaidi",
  "tab.profile.mapDefaultsHeading": "Chaguo-msingi za ramani",
  "tab.profile.mapDefaultsNote": "Anza na ramani hii ya msingi, miinuko na mipangilio ya tabaka kila unapofungua ramani ambayo kiungo chake hakiweki mipangilio yake. Viungo unavyoshiriki bado vinaonyesha hasa kile unachokiona.",
  "tab.profile.mapDefaultsSave": "Hifadhi kama chaguo-msingi zangu",
  "tab.profile.mapDefaultsForget": "Sahau",
  "tab.info.title": "Maelezo",
  "tab.info.controlsHeading": "Vidhibiti",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + buruta",
  "tab.info.shiftDragDesc": "Teua shughuli ndani ya kisanduku. Kwenye skrini ya kugusa, gusa <i class=\"hf-object-group\"></i> kwanza, kisha buruta kwa kidole kimoja. Shughuli ya mwisho kuteuliwa inaonyesha maelezo yake, na orodha ya shughuli husogea hadi ilipo.",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + buruta",
  "tab.info.ctrlDragDesc": "Zungusha na inamisha ramani kwa 3D, au tumia vidole viwili",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "Fungua au funga upau wa pembeni",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "Kichupo cha awali au kinachofuata",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "Funga upau wa pembeni",
  "tab.info.liveUrlHeading": "Kiungo Hai",
  "tab.info.liveUrlDesc": "Mwonekano wa ramani na mipangilio ya uhuishaji huhifadhiwa kwenye kiungo cha ukurasa, hivyo yeyote utakayemtumia ataona mwonekano ule ule.",
  "tab.info.videoHeading": "Hamisha Video",
  "tab.info.videoDesc": "Kitufe cha <i class=\"hf-video-camera\"></i> hurekodi uhuishaji kama MP4: kiguse, rekebisha kisanduku juu ya sehemu ya ramani unayotaka, kisha gusa tena kurekodi. Mzunguko mmoja kamili wa uhuishaji hurekodiwa, hivyo video hujirudia bila mshono; mzunguko unaozidi sekunde {max} (video ndefu zaidi ambayo Strava inakubali) hukatwa kwenye {max}.",
  "tab.info.contributeHeading": "Changia",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> Tufadhili kwenye GitHub",
  "tab.info.contactsHeading": "Mawasiliano",
  "map.basemapAndTerrain": "Ramani ya msingi na miinuko",
  "map.pauseAnimation": "Sitisha uhuishaji",
  "map.resumeAnimation": "Endelea na uhuishaji",
  "capture.record": "Rekodi video (mzunguko wa sek {period})",
  "capture.recordTruncated": "Rekodi video (mzunguko mmoja ni sek {period}; sek {max} za kwanza tu zitarekodiwa)",
  "capture.recordArea": "Rekodi eneo lililo ndani ya kisanduku",
  "capture.stop": "Acha kurekodi",
  "capture.selectionTooSmall": "eneo lililoteuliwa ni dogo mno",
  "capture.saved": "imehifadhiwa {name} ({size})",
  "capture.cancelled": "kurekodi kumeghairiwa",
  "capture.failed": "kurekodi kumeshindikana: {error}",
  "capture.loadingEncoder": "inapakia kisimbaji…",
  "capture.waitingForMap": "inasubiri ramani ipakie…",
  "capture.encoding": "inasimba… {percent}%",
  "capture.finalizing": "inakamilisha…",
  "share.title": "Shiriki kiungo cha ramani hii",
  "share.copied": "kiungo kimenakiliwa",
  "share.copiedUnshared": "kiungo kimenakiliwa — lakini ramani yako haijashirikiwa, kwa hiyo hakuna mtu mwingine anayeweza kuifungua. Washa “Ramani za Kushiriki” ili kubadilisha hilo.",
  "share.unshared": "Ramani yako haijashirikiwa, kwa hiyo hakuna mtu mwingine anayeweza kufungua kiungo hiki. Washa “Ramani za Kushiriki” ili kubadilisha hilo.",
  "share.copyThis": "Nakili kiungo hiki:",
  "update.available": "Toleo jipya la Heatflask linapatikana.",
  "update.reload": "Pakia upya",
  "import.title": "Inapakia",
  "import.stop": "Acha",
  "import.stopping": "inasimama…",
  "import.contacting": "inawasiliana na Strava…",
  "import.countOf": "Shughuli: {received} kati ya {total}",
  "import.count": "Shughuli: {received}",
  "import.waitStrava": "Imesitishwa hadi {time} kwa sababu ya kikomo cha upakuaji cha Strava. Acha ukurasa huu wazi; kupakia upya hakutaharakisha.",
  "import.waitRationed": "Upakuaji wa haraka wa leo umekwisha. Zilizobaki zitaendelea saa {time}, polepole zaidi. Acha ukurasa huu wazi.",
  "import.dailyLimit": "Kikomo cha upakuaji cha kila siku cha Strava kimefikiwa. Jaribu tena baada ya {time}.",
  "import.dailyRationed": "Sehemu yako ya upakuaji kutoka Strava kwa leo imekwisha. Jaribu tena baada ya {time}.",
  "import.noActivitiesYet": "Akaunti yako ya Strava bado haina shughuli yoyote. Rekodi au pakia moja kwenye Strava na itaonekana hapa.",
  "table.noActivities": "hakuna shughuli",
  "table.untitled": "(bila jina)",
  "activities.pageTitle": "{app} — Orodha ya Shughuli",
  "activities.heading": "Orodha ya Shughuli",
  "activities.fetching": "Inaleta shughuli...",
  "activities.rateLimit": "Kikomo cha maombi cha Strava kimefikiwa; tutaendelea saa {time}",
  "activities.noData": "Samahani, hakuna data &#128577;",
  "activities.colServerCache": "Njia imehifadhiwa kwenye seva (Mongo)",
  "activities.colBrowserCache": "Njia imehifadhiwa kwenye kivinjari hiki",
  "activities.cachedServer": "Njia ya {id} imehifadhiwa kwenye seva",
  "activities.notCachedServer": "Njia ya {id} haijahifadhiwa kwenye seva",
  "activities.cachedBrowser": "Njia ya {id} imehifadhiwa kwenye kivinjari hiki",
  "activities.notCachedBrowser": "Njia ya {id} haijahifadhiwa kwenye kivinjari hiki",
  "sport.AlpineSki": "Kuteleza kwenye theluji milimani",
  "sport.BackcountrySki": "Kuteleza kwenye theluji porini",
  "sport.Badminton": "Badminton",
  "sport.Basketball": "Mpira wa kikapu",
  "sport.Canoeing": "Kuendesha mtumbwi",
  "sport.Cricket": "Kriketi",
  "sport.Crossfit": "Crossfit",
  "sport.Dance": "Kucheza dansi",
  "sport.EBikeRide": "Safari ya baiskeli ya umeme",
  "sport.Elliptical": "Mashine ya eliptiki",
  "sport.EMountainBikeRide": "Safari ya baiskeli ya milimani ya umeme",
  "sport.Golf": "Gofu",
  "sport.GravelRide": "Safari ya changarawe",
  "sport.Handcycle": "Baiskeli ya mkono",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "Matembezi milimani",
  "sport.IceSkate": "Kuteleza kwenye barafu",
  "sport.InlineSkate": "Kuteleza kwa magurudumu",
  "sport.Kayaking": "Kuendesha kayak",
  "sport.Kitesurf": "Kuteleza kwa kishada",
  "sport.MountainBikeRide": "Safari ya baiskeli ya milimani",
  "sport.NordicSki": "Kuteleza kwenye theluji tambarare",
  "sport.Padel": "Padel",
  "sport.PhysicalTherapy": "Tiba ya viungo",
  "sport.Pickleball": "Pickleball",
  "sport.Pilates": "Pilates",
  "sport.Racquetball": "Racquetball",
  "sport.Ride": "Safari ya baiskeli",
  "sport.RockClimbing": "Kupanda miamba",
  "sport.RollerSki": "Roller ski",
  "sport.Rowing": "Kupiga makasia",
  "sport.Run": "Kukimbia",
  "sport.Sail": "Kusafiri kwa tanga",
  "sport.Skateboard": "Ubao wa kuteleza",
  "sport.Snowboard": "Ubao wa theluji",
  "sport.Snowshoe": "Viatu vya theluji",
  "sport.Soccer": "Kandanda",
  "sport.Squash": "Squash",
  "sport.StairStepper": "Mashine ya ngazi",
  "sport.StandUpPaddling": "Kupiga kasia ukisimama",
  "sport.Surfing": "Kuteleza mawimbini",
  "sport.Swim": "Kuogelea",
  "sport.TableTennis": "Tenisi ya mezani",
  "sport.Tennis": "Tenisi",
  "sport.TrailRun": "Kukimbia njiani porini",
  "sport.Velomobile": "Velomobile",
  "sport.VirtualRide": "Safari ya baiskeli ya mtandaoni",
  "sport.VirtualRow": "Kupiga makasia mtandaoni",
  "sport.VirtualRun": "Kukimbia mtandaoni",
  "sport.Volleyball": "Voliboli",
  "sport.Walk": "Kutembea",
  "sport.WeightTraining": "Mazoezi ya uzito",
  "sport.Wheelchair": "Kiti cha magurudumu",
  "sport.Windsurf": "Kuteleza kwa tanga",
  "sport.Workout": "Mazoezi",
  "sport.Yoga": "Yoga"
}
